export function findFlagByPrefix(flags, prefix) {
    for (const name of Object.keys(flags).sort()) {
        if (name.startsWith(prefix)) {
            return flags[name];
        }
    }
    return null;
}
